import { validateReportRange } from "../reports/crmReportMetrics";
import CommercialFilterBar from "../CommercialFilterBar";
import { useCommercialFilters } from "../CommercialFilterContext";
import { commercialRange, filterCommercialPipeline } from "../commercialFilters";
import { pipelineExpansion, oportunidadesAbiertas } from "./expansionMetrics";
import { useState, useMemo } from "react";
import { Alert, Box, Stack, Button, ToggleButton, ToggleButtonGroup } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SectionHeader from "../ui/SectionHeader";
import ExpansionKanban from "./ExpansionKanban";
import ExpansionList from "./ExpansionList";
import OportunidadFormDialog from "./OportunidadFormDialog";
import OportunidadSeguimientoDialog from "./OportunidadSeguimientoDialog";

export default function ExpansionPanel({ store, onNuevaVenta }) {
  const { filters, setFilters } = useCommercialFilters();
  const range = useMemo(() => commercialRange(filters, store), [filters, store]);
  const rangeError = validateReportRange(range.from, range.to);
  const filtered = useMemo(() => filterCommercialPipeline(store, filters, range), [store, filters, range]);
  const boardStore = { ...filtered, leads: store.leads };
  const [vista, setVista] = useState("kanban");
  const [openForm, setOpenForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [seguimientoOpp, setSeguimientoOpp] = useState(null);
  const [mostrarArchivo, setMostrarArchivo] = useState(false);
  const r = { pipelineExpansion: pipelineExpansion(filtered.oportunidadesExpansion), oportunidadesAbiertas: oportunidadesAbiertas(filtered.oportunidadesExpansion).length };
  const moneda = store.config.moneda || "";

  const openEdit = (opp) => {
    setEditData(opp);
    setOpenForm(true);
  };

  return (
    <Box>
      <SectionHeader
        title="Oportunidades"
        description={`Primera venta y ventas adicionales · ${moneda} ${r.pipelineExpansion.toLocaleString()} estimado en ${r.oportunidadesAbiertas} ${r.oportunidadesAbiertas === 1 ? "oportunidad abierta" : "oportunidades abiertas"}`}
        action={
          <Stack direction="row" spacing={1} alignItems="center">
            <ToggleButtonGroup size="small" value={vista} exclusive onChange={(_, v) => v && setVista(v)} aria-label="Vista">
              <ToggleButton value="kanban">Tablero</ToggleButton>
              <ToggleButton value="lista">Lista</ToggleButton>
            </ToggleButtonGroup>
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => { setEditData(null); setOpenForm(true); }}>
              Nueva oportunidad
            </Button>
          </Stack>
        }
        sx={{ mb: 2 }}
      />

      <CommercialFilterBar store={store} filters={filters} setFilters={setFilters} pipeline />
      {rangeError && <Alert severity="warning" sx={{ mb: 2 }}>{rangeError}</Alert>}
      {vista === "kanban" ? (
        <ExpansionKanban
          store={{ ...boardStore, moverOportunidadEtapa: (id, etapa) => { const opp = store.oportunidadesExpansion.find(o => o.id === id); if (etapa === "ganada") onNuevaVenta?.(opp.leadId, id); else if (etapa === "perdida") openEdit({ ...opp, etapa }); else store.moverOportunidadEtapa(id, etapa); } }}
          onEdit={openEdit}
          onSeguimiento={setSeguimientoOpp}
          mostrarArchivo={mostrarArchivo}
          setMostrarArchivo={setMostrarArchivo}
        />
      ) : (
        <ExpansionList store={boardStore} onEdit={openEdit} onSeguimiento={setSeguimientoOpp} />
      )}

      <OportunidadFormDialog
        open={openForm}
        onClose={() => { setOpenForm(false); setEditData(null); }}
        store={store}
        editData={editData}
        onNuevaVenta={onNuevaVenta}
      />
      <OportunidadSeguimientoDialog
        open={Boolean(seguimientoOpp)}
        onClose={() => setSeguimientoOpp(null)}
        store={store}
        oportunidad={seguimientoOpp}
      />
    </Box>
  );
}
